<template>
    <categorie-table :user-id="userId"></categorie-table>
</template>

<script>
import CategorieTable from './CategorieTable.vue'

export default {
    props: {
        userId: {
            type: [Number, String, null],
            default: null,
        },
        token: {
            type: String,
            default: '',
        },
    },
    components: {
        CategorieTable,
    },
}
</script>
